var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center alertMessage",attrs:{"aria-live":"polite"}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-alert")]),_c('p',{staticClass:"alertMessage my-0"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }